// --------------------------------------------------------
// CardListGhe - CardListGhe
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import {
  BodyCardListGhe,
  ContainerCardLisGhe,
  SubContentCardList,
} from "./CardListGhe.styled";
import Avatar from "@mui/material/Avatar";
import AvatarPS from "../../assets/imgs/postodetrabalho.svg";
import { H3 } from "../UI/generalLayout/Layout.styled";
import GheDropdown from "../dropdownGhe/GheDropdown";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CardListGhe INTERFACE
// --------------------------------------------------------

interface ICardListGhe {
  nomePosto: string;
  idRelation: string;
  idSaude: string;
  id: string;
  saudesOcupacionais: any;
  data: any;
  attRelationShip: any;

}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CardListGhe = ({ id, data, idRelation, idSaude, nomePosto, saudesOcupacionais, attRelationShip}: ICardListGhe) => {
  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
        <ContainerCardLisGhe>
          <BodyCardListGhe>
            <SubContentCardList>
              <Avatar alt="Remy Sharp" src={AvatarPS} />
              <H3 style={{ marginLeft: "10px" }}>{data.postoTrabalhoNome}</H3>
            </SubContentCardList>
            <SubContentCardList>
              <GheDropdown
                value={data.saudeOcupacional}
                arraySaude={saudesOcupacionais}
                disabled={false}
                style={{ width: "286px", height: "49px" }}
                multiple={false}
                id={id}
                idSaude={idSaude}
                attRelationShip={attRelationShip}
             
              />
            </SubContentCardList>
          </BodyCardListGhe>
          {(!!data && data.saudeOcupacional.id === '') ? (
            <ErrorOutlineOutlinedIcon style={{ color: "#EF4444" }} />
          ) : (
            ""
          )}
        </ContainerCardLisGhe>
    </>
  );
};

export default CardListGhe;
